import { useState, useEffect } from 'react';

/**
 * Hook to check if the component is mounted (client-side only).
 * Useful for avoiding hydration mismatches with components that generate
 * dynamic IDs (like Radix UI components).
 */
export function useIsMounted() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return isMounted;
}
